module.exports = __webpack_public_path__ + "static/media/spidercrab_magnet.4687b8c1.webp";